import React, {useEffect, useRef, useState} from 'react';
import smsgatewayService from '../../../../services/smsgateway.service';
import {useParams} from 'react-router-dom';
import {useEyeconxStore} from '../../../../store/eyeconxStore';
import Loading from "../../layout/Loading";

const Message = ({ message }) => {
    const isOutgoing = message.messageType === "OUTGOING";

    function linkify(text, isOutgoing) {
        const urlRegex = /(https?:\/\/[^\s]+|www\.[^\s]+)/g;
        return text.replace(urlRegex, (url) => {
            const href = url.startsWith("http") ? url : `https://${url}`;
            const linkClass = isOutgoing ? 'text-white text-decoration-underline' : 'text-primary';
            return `<a href="${href}" target="_blank" rel="noopener noreferrer" class="${linkClass}">${url}</a>`;
        });
    }

    return (
        <div className={`d-flex mb-3 ${isOutgoing ? 'justify-content-end' : 'justify-content-start'}`}>
            <div
                className={`d-flex flex-column ${isOutgoing ? 'align-items-end' : 'align-items-start'}`}
                style={{maxWidth: '80%'}}
            >
                <div
                    className={`p-3 rounded-4 ${isOutgoing ?
                        'bg-primary text-white' :
                        'bg-light'}`}
                >
                    <div
                        className="mb-1"
                        dangerouslySetInnerHTML={{__html: linkify(message.message, isOutgoing)}}
                    />
                    <div className={`text-end small ${isOutgoing ? 'text-white-50' : 'text-muted'}`}>
                        {new Date(message.modifiedAt).toLocaleTimeString([], {hour: '2-digit', minute: '2-digit'})}
                    </div>
                </div>
            </div>
        </div>
    );
};

const SmsConversation = () => {
    const {conversationId} = useParams();
    const clinicId = useEyeconxStore(state => state.user.clinicId);
    const [messages, setMessages] = useState([]);
    const [page, setPage] = useState(0);
    const [pageSize] = useState(10);
    const [loading, setLoading] = useState(false);
    const [hasMore, setHasMore] = useState(true);
    const observer = useRef();
    const messagesEndRef = useRef(null);

    useEffect(() => {
        loadMessages(page, pageSize);
    }, [page]);

    useEffect(() => {
        scrollToBottom();
    }, [messages]);

    const scrollToBottom = () => {
        messagesEndRef.current?.scrollIntoView({behavior: "smooth"});
    };

    const loadMessages = async (pageNo, pageSize) => {
        setLoading(true);
        try {
            const response = await smsgatewayService.getConversation(clinicId, conversationId, pageNo, pageSize);
            setMessages(prevMessages => [...response.data.content.reverse(), ...prevMessages]);
            setHasMore(!response.data.last);
        } catch (error) {
            console.error("Error loading messages", error);
        }
        setLoading(false);
    };

    const lastMessageElementRef = useRef();
    useEffect(() => {
        if (loading) return;
        if (observer.current) observer.current.disconnect();
        observer.current = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting && hasMore) {
                setPage(prevPage => prevPage + 1);
            }
        });
        if (lastMessageElementRef.current) {
            observer.current.observe(lastMessageElementRef.current);
        }
    }, [loading, hasMore]);

    return (
        <div className="container mt-3">
            <div className="d-flex flex-column" style={{height: "70vh"}}>
                <div className="card flex-grow-1 shadow-sm">
                    <div className="card-header bg-white border-bottom">
                        <h5 className="card-title mb-0">
                            <i className="bi bi-person-circle me-2"></i>
                            Yash Sompura (Yash)
                        </h5>
                    </div>
                    <div
                        className="card-body p-3 overflow-auto"
                        style={{height: "65vh"}}
                    >
                        {loading && (
                            <Loading/>
                        )}

                        {messages.map((message, index) => (
                            <div
                                key={`${message.id}-${index}`}
                                ref={index === 0 ? lastMessageElementRef : null}
                            >
                                <Message message={message}/>
                            </div>
                        ))}

                        <div ref={messagesEndRef}/>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SmsConversation;